import { IPopularItems } from "../../ISearch";

export const popularItemsEs: Array<IPopularItems> = [
  {
    label: "Pan",
    href: "/search?s=pan"
  },
  {
    label: "Pizza",
    href: "/search?s=pizza"
  },
  {
    label: "Pollo",
    href: "/search?s=pollo"
  },
  {
    label: "Pan keto",
    href: "/search?s=pan+keto"
  },
  {
    label: "Postres",
    href: "/search?s=postres"
  },
  {
    label: "Desayuno",
    href: "/search?s=desayuno"
  },
  {
    label: "Chocolate",
    href: "/search?s=chocolate"
  },
  {
    label: "Keto",
    href: "/search?s=keto"
  },
  {
    label: "Guías",
    href: "/keto/guias"
  },
  {
    label: "Vídeos",
    href: "/video"
  }
];
